module.exports = __webpack_public_path__ + "static/media/grid.d10931b3.svg";